import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, BarChart3 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <ShieldCheck className="w-8 h-8 text-amber-500" data-id="element-26" />,
    text: 'Menos gastos innecesarios por decisiones impulsivas.'
  }, {
    icon: <BarChart3 className="w-8 h-8 text-amber-500" data-id="element-27" />,
    text: 'Campañas que duran más y se estabilizan mejor.'
  }, {
    icon: <Zap className="w-8 h-8 text-amber-500" data-id="element-28" />,
    text: 'Optimización real en vez de reinicios constantes.'
  }];
  return <section className="py-24 px-4 bg-[#0d0d14] relative overflow-hidden" data-id="element-29">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-31">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-32">
            Lo que cambia cuando aplicas estos 10 secretos
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-33">
            Cuando dejas de sabotear el aprendizaje y ejecutas con orden, sucede
            algo:{' '}
            <strong className="text-white" data-id="element-34">
              Andrómeda empieza a operar con señales limpias. Y tú dejas de
              adivinar.
            </strong>
          </p>
          <p className="text-lg text-blue-400 mt-4 font-semibold" data-id="element-35">
            Eso significa:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-36">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-[#15151e] border border-gray-800 rounded-2xl p-8 flex flex-col items-center text-center" data-id="element-37">
              <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mb-6" data-id="element-38">
                {benefit.icon}
              </div>
              <p className="text-lg font-medium text-white" data-id="element-39">{benefit.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}